import { z } from 'zod';

// All realtime events are emitted as { type, id, ... } payloads under the channel "data-changed".
export const incidentNewEvent = z.object({
  type: z.literal('incident:new'),
  id: z.number().int().positive(),
  service_id: z.number().int().positive(),
});

export const incidentResolvedEvent = z.object({
  type: z.literal('incident:resolved'),
  id: z.number().int().positive(),
});

export const announcementNewEvent = z.object({
  type: z.literal('announcement:new'),
  id: z.number().int().positive(),
});

export const announcementUpdatedEvent = z.object({
  type: z.literal('announcement:updated'),
  id: z.number().int().positive(),
});

export const dataChangedEvent = z.discriminatedUnion('type', [
  incidentNewEvent,
  incidentResolvedEvent,
  announcementNewEvent,
  announcementUpdatedEvent,
]);
export type DataChangedEvent = z.infer<typeof dataChangedEvent>;

export const SOCKET_EVENT_CHANNEL = 'data-changed' as const;
